import Heading from "components/ui/Heading/Heading";
import { Button } from "components/ui";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import Filter from "components/dashboard/common/Filter/Filter";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import "./UpdatesHeader.scss";

const UpdatesHeader = ({
    title,
    subTitle,
    btnText,
    placeholder,
    handleClick,
    handleSearch,
    searchIsLoading,
    clearSearch,
    defaultValue,
    handleSortByAlpha,
    handleSortByDate,
    handleSortByLastModified,
    baseFilter,
    filterOption,
    handleBasefilter,
    baseResources,
}) => {
    const createButton = (
        <Button classType={"primary"} onClick={() => handleClick?.()}>
            <ReactSVG src={asset?.icons?.addPlusIcon} />
            {btnText}
        </Button>
    );

    return (
        <>
            <div className='updates-header'>
                <div className='updates-header__top'>
                    <Heading headingText={title} headingSubText={subTitle} />
                    {baseResources ? (
                        <ComponentAccessControl baseResources={baseResources}>
                            {createButton}
                        </ComponentAccessControl>
                    ) : (
                        createButton
                    )}
                </div>
                <Filter
                    handleSortByAlpha={handleSortByAlpha}
                    handleSortByDate={handleSortByDate}
                    hideClassFilter={true}
                    handleSearch={handleSearch}
                    searchIsLoading={searchIsLoading}
                    clearSearch={clearSearch}
                    searchPlaceholder={placeholder}
                    handleSortByLastModified={handleSortByLastModified}
                    baseFilter={baseFilter}
                    filterOption={filterOption}
                    handleBasefilter={handleBasefilter}
                    searchDefaultValue={defaultValue}
                />
            </div>
        </>
    );
};

export default UpdatesHeader;
